import { LDSHeading } from "@resmed/lumina-design-system";
import type { CalloutData } from "../../features/chat/types/UIMessage";

export interface RepliedWidgetProps {
  calloutData: CalloutData[];
}

/** White card shown inside the bubble for replied/callout messages — mirrors mobile RepliedWidget. */
const RepliedWidget = ({ calloutData }: RepliedWidgetProps) => (
  <div className="lds-flex lds-flex-col lds-gap-1 lds-mb-2">
    {calloutData.map((item, i) => (
      <div
        key={i}
        className="lds-bg-white lds-rounded-md lds-border lds-border-bordercolor-default lds-px-3 lds-py-2"
      >
        <div className="lds-flex lds-items-center lds-gap-2 lds-mb-0.5">
          <LDSHeading size="h5" className="lds-text-xs lds-font-semibold lds-text-textcolor-default">
            {item.name}
          </LDSHeading>
          {item.time && (
            <LDSHeading size="h5" className="lds-text-xs lds-font-normal lds-text-textcolor-caption lds-shrink-0">
              {item.time}
            </LDSHeading>
          )}
        </div>
        <LDSHeading size="h5" className="lds-font-normal lds-text-sm lds-text-textcolor-weak lds-leading-snug">
          {item.message}
        </LDSHeading>
      </div>
    ))}
  </div>
);

export default RepliedWidget;
